module.exports = __webpack_public_path__ + "img/plus-gray.7f084963.svg";